import request from '@/utils/httpRequest'

export default class LeaseService {
    queryById (id) {
        return request({
            url: '/leasing/shyeLease/queryById',
            method: 'get',
            params: {id: id}
        })
    }

    startFlow (params) {
        return request({
            url: '/leasing/shyeLease/startFlow',
            method: 'post',
            data: params
        })
    }

}
